import { useState } from 'react';
import { ColumnDetailsMap } from '../../../shared/models/ColumnDetailsMap';
import { ColumnDetails } from '../../../shared/models/ColumnDetails';

type UseTableSettingsProps = {
  dashboardColumnOrder: string[];
  columnsDetailsDescriptor: ColumnDetailsMap;
};

export const useTableSettings = ({ dashboardColumnOrder, columnsDetailsDescriptor }: UseTableSettingsProps) => {
  const [showTableSettingsDialog, setShowTableSettingsDialog] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [columnsDetails, setColumnsDetails] = useState<ColumnDetailsMap>(columnsDetailsDescriptor);
  const [columnOrder, setColumnOrder] = useState<string[]>(dashboardColumnOrder);

  const handleToggleTableSettingsDialog = () => setShowTableSettingsDialog(prev => !prev);

  const handleColumnChange = (
    newColumnOrder: string[],
    newHiddenColumns: string[],
    newColumnsDetails = columnsDetails
  ) => {
    setColumnOrder(newColumnOrder);
    setHiddenColumns(newHiddenColumns);
    setColumnsDetails(newColumnsDetails);
  };

  const handleColumnDetailsChange = (column: string, newColumnDetails: ColumnDetails) => {
    setColumnsDetails(prev => ({
      ...prev,
      [column]: newColumnDetails,
    }));
  };

  return {
    showTableSettingsDialog,
    setShowTableSettingsDialog,
    hiddenColumns,
    setHiddenColumns,
    columnsDetails,
    setColumnsDetails,
    columnOrder,
    setColumnOrder,
    handleToggleTableSettingsDialog,
    handleColumnChange,
    handleColumnDetailsChange,
  };
};